@if (!invoiceOcrCompleted) {
  <div class="field-control" id="invoice-ocr-box">
    <label class="field-label"
      >{{ "COO.OCR.FIELD_LABEL" | translate }}
      <!-- <span class="text-red-600" aria-hidden="true">*</span>   -->
    </label>
    <div
      class="rounded-2xl border-1 border-dc-navy bg-linear-to-b from-[#f3f7ff] to-[#edf3ff] px-4 py-4"
    >
      <!-- <div class="mx-auto max-w-3xl rounded-[1.35rem] border border-[#c6d5f0] bg-white/70 p-4 shadow-[0_8px_24px_rgba(18,61,141,0.08)] max-sm:p-3"> -->
      <!-- <div class="mb-3 flex items-center gap-3">
        <img
          src="icons/invoice_ai_logo.png"
          [alt]="'COO.OCR.TITLE' | translate"
          class="h-10 w-10 shrink-0 object-contain max-sm:h-9 max-sm:w-9"
        />
        <div class="min-w-0">
          <p class="m-0 text-lg font-bold text-dc-navy max-sm:text-base">
            {{ "COO.OCR.FIELD_LABEL" | translate }}
          </p>
          <h3 class="m-0 text-[1.7rem] leading-tight font-bold text-dc-black max-sm:text-[1.35rem]">
            {{ "COO.OCR.TITLE" | translate }}
          </h3>
        </div>
      </div> -->

      <div class="hidden items-center justify-between gap-6 sm:flex">
        <div class="flex min-w-0 items-center gap-4">
          <img
            src="icons/invoice_ai_logo.png"
            [alt]="'COO.OCR.TITLE' | translate"
            class="h-12 w-12 shrink-0"
          />

          <div class="min-w-0">
            <!-- <p class="text-sm font-bold text-dc-navy">
                {{ "COO.OCR.FIELD_LABEL" | translate }}
              </p>
              <h3 class="mt-1 text-2xl leading-tight font-bold text-dc-black">
                {{ "COO.OCR.TITLE" | translate }}
              </h3> -->
            <h3 class="mt-1 text-base font-semibold text-dc-black">
              {{ "COO.OCR.UPLOAD_HINT" | translate }}
            </h3>
            <p class="mt-1 text-[0.95rem] text-[#76839b]">
              {{ "COO.OCR.FILE_RULES" | translate }}
            </p>
          </div>
        </div>

        <div class="flex shrink-0 items-center gap-3">
          <div
            class="inline-flex items-center gap-2 rounded-full bg-[rgba(240,90,0,0.12)] px-4 py-2 text-[1rem] font-bold text-[#f05a00]"
          >
            <i class="fa-solid fa-bolt text-[0.9rem]"></i>
            <span>{{ "COO.OCR.FAST_BADGE" | translate }}</span>
          </div>

          <!-- <button
              type="button"
              class="btn-edge-cut btn-primary-small"
              (click)="openInvoiceOcrModal()"
            >
              {{ "COO.OCR.START_SCANNING" | translate }}
            </button> -->
          <app-button
            type="button"
            classesName="btn-edge-cut btn-primary-small"
            [label]="'COO.OCR.START_SCANNING' | translate"
            (onBtnClick)="openInvoiceOcrModal()"
          ></app-button>
        </div>
      </div>

      <div class="flex items-center gap-3 sm:hidden">
        <img
          src="icons/invoice_ai_logo.png"
          [alt]="'COO.OCR.TITLE' | translate"
          class="h-11 w-11 shrink-0 max-sm:h-10 max-sm:w-10"
        />

        <div class="min-w-0 flex-1">
          <p
            class="text-[1.02rem] font-semibold leading-snug text-[#23324d] max-sm:text-[0.96rem]"
          >
            {{ "COO.OCR.UPLOAD_HINT" | translate }}
          </p>
          <p
            class="mt-0.5 text-[0.9rem] leading-snug text-[#76839b] max-sm:text-[0.82rem]"
          >
            {{ "COO.OCR.FILE_RULES" | translate }}
          </p>
        </div>
      </div>

      <div
        class="mt-3 flex items-center justify-end gap-3 max-sm:flex-wrap max-sm:justify-start sm:hidden"
      >
        <div
          class="inline-flex items-center gap-2 rounded-full bg-[rgba(240,90,0,0.12)] px-3 py-1.5 text-[0.92rem] font-bold text-[#f05a00]"
        >
          <i class="fa-solid fa-bolt text-[0.85rem]"></i>
          <span>{{ "COO.OCR.FAST_BADGE" | translate }}</span>
        </div>

        <!-- <button
            type="button"
           class="btn-edge-cut btn-primary-small"
           (click)="openInvoiceOcrModal()"
          >
            {{ "COO.OCR.START_SCANNING" | translate }}
          </button> -->
        <app-button
          type="button"
          classesName="btn-edge-cut btn-primary-small"
          [label]="'COO.OCR.START_SCANNING' | translate"
          (onBtnClick)="openInvoiceOcrModal()"
        ></app-button>
      </div>
      <!-- </div> -->
    </div>
  </div>
}

@if (invoiceOcrCompleted) {
  <div class="field-control">
    <div
      class="flex items-start gap-4 rounded-3xl border border-[#d6dce7] bg-[#eef4f9] px-5 py-4 max-sm:items-start max-sm:px-4 max-sm:py-3"
    >
      <div class="shrink-0 text-xl leading-none text-[#4b5a74]">
        <i class="fa-solid fa-circle-info"></i>
      </div>
      <p
        class="m-0 text-[1.2rem] leading-snug text-[#1f2a3d] max-sm:text-[1.05rem]"
      >
        {{ "COO.OCR.REVIEW_SUBTITLE" | translate }}
      </p>
    </div>

    <div
      class="mt-4 flex items-center justify-between gap-4 rounded-3xl border border-[#d6dce7] bg-white px-5 py-4 max-sm:gap-3 max-sm:px-4 max-sm:py-3"
    >
      <div class="flex min-w-0 flex-col items-start gap-3">
        <div class="flex min-w-0 items-center gap-3">
          <div
            class="grid size-8 shrink-0 place-items-center rounded-full bg-[#11823b] text-base text-white"
          >
            <i class="fa-solid fa-check"></i>
          </div>
          <strong
            class="whitespace-nowrap text-[1.85rem] font-bold text-[#11823b] max-sm:text-[1.55rem]"
          >
            {{ "COO.OCR.SCANNED_TITLE" | translate }}
          </strong>
        </div>
        <span
          class="w-fit whitespace-nowrap rounded-[18px] bg-[#eef2f5] px-4 py-[0.45rem] text-[1.05rem] font-bold text-[#5c616b] max-sm:px-3 max-sm:py-[0.4rem] max-sm:text-[0.9rem]"
        >
          {{ "COO.OCR.ACCURACY" | translate: { value: invoiceOcrAccuracy } }}
        </span>
      </div>
      <!-- <button
      type="button"
      class="card-edge-cut-white inline-flex min-w-[12rem] shrink-0 items-center justify-center gap-3 px-5 py-3 text-[1.1rem] font-bold text-dc-navy max-sm:min-w-[6.8rem] max-sm:px-4 max-sm:py-2.5 max-sm:text-base"
      (click)="redoInvoiceOcr()"
    >
      <i class="fa-solid fa-rotate-left text-[1.3rem]"></i>
      <span>{{ "COO.OCR.REDO" | translate }}</span>
    </button> -->
      <app-button
        type="button"
        classesName="btn-edge-cut btn-primary-small"
        [label]="'COO.OCR.REDO' | translate"
        (onBtnClick)="redoInvoiceOcr()"
        [iconClass]="'fa-solid fa-rotate-left text-[1.3rem]'"
      ></app-button>
    </div>
  </div>
}

@if (showInvoiceOcrModal) {
  <dialog
    #invoiceOcrUploadDialog
    class="dc-modal m-0 h-screen max-h-none w-screen max-w-none border-0 bg-transparent p-2 !z-[9999] backdrop:bg-black/50 sm:p-4"
  >
    <div class="dc-modal-container bg-white max-w-[720px]!">
      <button
        class="modal-x-button"
        type="button"
        (click)="closeInvoiceOcrModal()"
      >
        <i class="fas fa-close"></i>
      </button>

      <div class="p-2">
        <h1 class="section-heading">
          {{ "COO.OCR.MODAL_TITLE" | translate }}
        </h1>
        <!-- <p class="mt-4 mb-6 text-[#60708d]">
        {{ "COO.OCR.MODAL_SUBTITLE" | translate }}
      </p> -->

        <label class="mb-3 block text-sm font-medium text-[#13233c]">
          {{ "COO.OCR.ATTACH_FILE" | translate }}
        </label>

        <input
          #invoiceOcrUploadInput
          id="invoice-ocr-upload-input"
          type="file"
          class="hidden"
          accept=".pdf"
          multiple
          (change)="onInvoiceOcrFileSelected($event)"
        />

        <button
          type="button"
          class="flex w-full items-center justify-between gap-4 rounded-[18px] border border-[#d8e0f0] bg-white px-4 py-3 text-left"
          (click)="openInvoiceOcrFilePicker()"
        >
          <span class="min-w-0 truncate text-[#7b8597]">
            @if (selectedPreviewFile) {
              {{ selectedPreviewFile.name }}
            } @else {
              {{ "COO.OCR.NO_FILE_CHOSEN" | translate }}
            }
          </span>
          <app-button
            classesName="card-edge-cut-white"
            [label]="'COO.OCR.UPLOAD_ACTION' | translate"
          ></app-button>
        </button>

        @if (invoiceOcrUploadErrorKey) {
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'VALIDATION_MSG.ERROR' | translate,
              message: invoiceOcrUploadErrorKey | translate,
            }"
            [showbutton]="false"
          ></app-validation-message>
        }

        @if (invoiceOcrUploadedFiles.length) {
          <div class="mt-6 space-y-4">
            @for (
              uploadedFile of invoiceOcrUploadedFiles;
              track uploadedFile.id
            ) {
              <div
                class="flex cursor-pointer items-center justify-between gap-4 rounded-[24px] border p-4 transition-colors"
                [class.border-[#123d8d]]="selectedPreviewFile?.id === uploadedFile.id"
                [class.bg-[#f4f8ff]]="selectedPreviewFile?.id === uploadedFile.id"
                [class.border-[#d8e0f0]]="selectedPreviewFile?.id !== uploadedFile.id"
                (click)="selectPreviewFile(uploadedFile.id)"
              >
                <div class="flex min-w-0 items-center gap-4">
                  <div
                    class="grid size-[3.25rem] shrink-0 place-items-center rounded-2xl bg-[rgba(240,90,0,0.12)] text-[#f05a00]"
                  >
                    <i class="fa-solid text-2xl fa-file-pdf"></i>
                  </div>
                  <div class="min-w-0">
                    <strong
                      class="block overflow-hidden text-ellipsis whitespace-nowrap text-[#13233c]"
                    >
                      {{ uploadedFile.name }}
                    </strong>
                    <span
                      class="mt-1 block overflow-hidden text-ellipsis whitespace-nowrap text-[#60708d]"
                    >
                      {{ uploadedFile.sizeLabel }}
                    </span>
                  </div>
                </div>
                <button
                  type="button"
                  class="cursor-pointer border-0 bg-transparent text-2xl text-[#7b8597]"
                  (click)="$event.stopPropagation(); removeInvoiceOcrFile(uploadedFile.id)"
                >
                  <i class="fa-solid fa-xmark"></i>
                </button>
              </div>
            }
          </div>

          <div class="mt-6">
            <label class="mb-3 block text-sm font-medium text-[#13233c]">
              {{ "COO.OCR.PREVIEW_TITLE" | translate }}
            </label>
            <div class="overflow-hidden rounded-[24px] border border-[#d8e0f0] bg-[#f8fbff]">
              <iframe
                class="h-[24rem] w-full"
                [src]="selectedPreviewFile?.safePreviewUrl"
                title="Invoice preview"
              ></iframe>
            </div>
            <div class="mt-2 text-right">
              <a
                class="text-sm font-medium text-dc-dark-blue underline underline-offset-4"
                [href]="selectedPreviewFile?.previewUrl"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ "COO.OCR.PREVIEW_OPEN_NEW_TAB" | translate }}
              </a>
            </div>
          </div>

          @if (invoiceOcrStatus === "uploading") {
            <div class="mt-4">
              <div
                class="h-[0.45rem] overflow-hidden rounded-full bg-[#dde4f0]"
              >
                <span
                  class="block h-full rounded-full bg-[#123d8d] transition-[width] duration-200 ease-in-out"
                  [style.width.%]="invoiceOcrProgress"
                ></span>
              </div>
              <div
                class="mt-2 flex justify-between gap-4 text-sm text-[#60708d]"
              >
                <span>
                  {{ "COO.OCR.UPLOADING" | translate }}
                </span>
                <strong>{{ invoiceOcrProgress }}%</strong>
              </div>
            </div>
          }
        }

        @if (invoiceOcrUploadedFiles.length) {
          <div class="mt-6 flex flex-wrap gap-4">
            <app-button
              classesName="card-edge-cut-white btn-width-auto"
              [label]="'BUTTONS.CANCEL' | translate"
              (onBtnClick)="cancelInvoiceOcrModal()"
            ></app-button>
            <app-button
              [classesName]="
                invoiceOcrStatus !== 'uploaded'
                  ? 'btn-width-auto'
                  : 'btn-edge-cut btn-width-auto'
              "
              [label]="'COO.OCR.SCAN_ACTION' | translate"
              (onBtnClick)="
                invoiceOcrStatus !== 'uploaded' ? null : scanInvoiceWithOcr()
              "
            ></app-button>
          </div>
        }
      </div>
    </div>
  </dialog>
}

@if (showInvoiceOcrEstimatedWaitModal) {
  <dialog
    #invoiceOcrEstimatedWaitDialog
    class="dc-modal m-0 h-screen max-h-none w-screen max-w-none border-0 bg-transparent p-2 !z-[9999] backdrop:bg-black/50 sm:p-4"
  >
    <div class="dc-modal-container bg-white min-w-3xs! max-w-[520px]!">
      <button
        class="modal-x-button"
        type="button"
        (click)="dismissInvoiceOcrEstimatedWaitModal()"
      >
        <i class="fas fa-close"></i>
      </button>

      <div class="p-8 text-center max-sm:p-5">
        <div
          class="mx-auto mb-6 grid size-20 place-items-center rounded-full bg-[rgba(18,61,141,0.08)] text-2xl text-[#123d8d]"
        >
          <i class="fa-solid fa-circle-info"></i>
        </div>
        <h2
          class="mb-3 text-2xl font-bold text-[#13233c] max-sm:text-[1.7rem]"
        >
          {{ "COO.OCR.ESTIMATED_WAIT_TIME.TITLE" | translate }}
        </h2>
        <p class="mb-6 text-base text-[#4a5871]">
          {{
            "COO.OCR.ESTIMATED_WAIT_TIME.MESSAGE"
              | translate : { minutes: invoiceOcrEstimatedWaitMinutes }
          }}
        </p>
        <div
          class="mt-6 flex items-center justify-center gap-4 max-sm:flex-col"
        >
          <app-button
            classesName="card-edge-cut-white"
            [label]="'COO.OCR.ENTER_MANUALLY' | translate"
            (onBtnClick)="enterInvoiceDetailsManually()"
          ></app-button>
          <app-button
            classesName="btn-edge-cut"
            [label]="'BUTTONS.CONTINUE' | translate"
            (onBtnClick)="continueInvoiceOcrAfterEstimatedWait()"
          ></app-button>
        </div>
      </div>
    </div>
  </dialog>
}

@if (showInvoiceOcrScanningModal) {
  <dialog
    #invoiceOcrScanningDialog
    class="dc-modal m-0 h-screen max-h-none w-screen max-w-none border-0 bg-transparent p-2 !z-[9999] backdrop:bg-black/50 sm:p-4"
  >
    <div class="dc-modal-container bg-white min-w-3xs! max-w-[460px]!">
      <div class="p-8 text-center max-sm:p-5">
        <div
          class="mx-auto mb-6 grid size-20 place-items-center rounded-full bg-[rgba(18,61,141,0.08)] text-2xl text-[#123d8d]"
        >
          <i class="fa-solid fa-rotate"></i>
        </div>
        <h2
          class="mb-3 text-2xl font-bold text-[#13233c] max-sm:text-[1.7rem]"
        >
          {{ "COO.OCR.SCANNING_TITLE" | translate }}
        </h2>
        <p class="mb-6 text-base text-[#4a5871]">
          {{ "COO.OCR.SCANNING_MESSAGE" | translate }}
        </p>
        <div>
          <div class="h-[0.45rem] overflow-hidden rounded-full bg-[#dde4f0]">
            <span
              class="block h-full rounded-full bg-[#123d8d] transition-[width] duration-200 ease-in-out"
              [style.width.%]="invoiceOcrScanProgress"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </dialog>
}

@if (showInvoiceOcrErrorModal) {
  <dialog
    #invoiceOcrErrorDialog
    class="dc-modal m-0 h-screen max-h-none w-screen max-w-none border-0 bg-transparent p-2 !z-[9999] backdrop:bg-black/50 sm:p-4"
  >
    <div class="dc-modal-container bg-white min-w-3xs! max-w-[520px]!">
      <button
        class="modal-x-button"
        type="button"
        (click)="dismissInvoiceOcrErrorModal()"
      >
        <i class="fas fa-close"></i>
      </button>

      <div class="p-8 text-center max-sm:p-5">
        <div
          class="mx-auto mb-6 grid size-20 place-items-center rounded-full bg-[rgba(240,90,0,0.1)] text-2xl text-[#f05a00]"
        >
          <i class="fa-solid fa-circle-exclamation"></i>
        </div>
        <h2
          class="mb-3 text-2xl font-bold text-[#13233c] max-sm:text-[1.7rem]"
        >
          {{ invoiceOcrErrorTitleKey | translate }}
        </h2>
        <p class="mb-6 text-base text-[#4a5871]">
          {{ invoiceOcrErrorMessageKey | translate }}
        </p>
        <div
          class="mt-6 flex items-center justify-center gap-4 max-sm:flex-col"
        >
          <app-button
            classesName="card-edge-cut-white"
            [label]="'COO.OCR.ENTER_MANUALLY' | translate"
            (onBtnClick)="enterInvoiceDetailsManually()"
          ></app-button>
          <app-button
            classesName="btn-edge-cut"
            [label]="'COO.OCR.TRY_AGAIN' | translate"
            (onBtnClick)="retryInvoiceOcr()"
          ></app-button>
        </div>
      </div>
    </div>
  </dialog>
}

@if (showInvoiceOcrServiceChoiceModal) {
  <dialog
    #invoiceOcrGspDialog
    class="dc-modal m-0 h-screen max-h-none w-screen max-w-none border-0 bg-transparent p-2 !z-[9999] backdrop:bg-black/50 sm:p-4"
  >
    <div class="dc-modal-container bg-white min-w-3xs! max-w-[520px]!">
      <div class="p-2">
        <h2 class="mb-3 text-2xl font-bold text-dc-black">
          {{ "COO.OCR.GSP_MODAL.TITLE" | translate }}
        </h2>

        <div
          class="mb-0 inline-flex items-center gap-2 rounded-md border-1 border-b-0 border-dc-navy bg-[#f5f8ff] px-3 py-2 text-xs font-semibold text-dc-navy"
        >
          <i class="fa-solid fa-wand-magic-sparkles"></i>
          <span>{{ "COO.OCR.GSP_MODAL.AI_SUGGESTION" | translate }}</span>
        </div>

        <div class="border border-dc-navy bg-white p-4">
          <h3 class="mb-3 text-lg font-bold text-dc-black">
            {{ "COO.OCR.GSP_MODAL.ELIGIBILITY" | translate }}
          </h3>

          <div
            class="grid grid-cols-[auto_1fr] gap-x-4 gap-y-4 text-sm text-[#4a5871]"
          >
            <span class="font-medium">{{
              "COO.OCR.GSP_MODAL.DESTINATION" | translate
            }}</span>
            <span class="text-right font-semibold text-dc-black">{{
              invoiceOcrGspModalData.destination ||
                ("COO.OCR.GSP_MODAL.DESTINATION_VALUE" | translate)
            }}</span>
            <span class="font-medium">{{
              "COO.OCR.GSP_MODAL.PRODUCT" | translate
            }}</span>
            <span class="text-right font-semibold text-dc-black">{{
              invoiceOcrGspModalData.product ||
                ("COO.OCR.GSP_MODAL.PRODUCT_VALUE" | translate)
            }}</span>
            <span class="font-medium">{{
              "COO.OCR.GSP_MODAL.AGREEMENT" | translate
            }}</span>
            <span class="text-right font-semibold text-dc-black">{{
              invoiceOcrGspModalData.agreement ||
                ("COO.OCR.GSP_MODAL.AGREEMENT_VALUE" | translate)
            }}</span>
            <span class="font-medium">{{
              "COO.OCR.GSP_MODAL.BENEFIT" | translate
            }}</span>
            <span class="text-right font-semibold text-dc-black">{{
              invoiceOcrGspModalData.benefit ||
                ("COO.OCR.GSP_MODAL.BENEFIT_VALUE" | translate)
            }}</span>
          </div>

          <div class="mt-5 rounded-2xl bg-[#f6fbf7] p-4">
            <h3 class="mb-2 text-base font-bold text-dc-black">
              {{ "COO.OCR.GSP_MODAL.SWITCH_TITLE" | translate }}
            </h3>
            <p class="mb-4 text-sm text-[#4a5871]">
              {{ "COO.OCR.GSP_MODAL.SWITCH_DESC" | translate }}
            </p>

            <div class="space-y-4">
              @for (
                field of invoiceOcrGspModalData.carriedOverFields;
                track field.label + field.value
              ) {
                <div
                  class="grid grid-cols-[minmax(0,1fr)_auto_auto] items-center gap-3 text-sm"
                >
                  <span class="text-[#4a5871]">{{ field.label }}</span>
                  <span class="text-right font-medium text-dc-black">{{
                    field.value
                  }}</span>
                  <i class="fa-solid fa-circle-check text-[#16a34a]"></i>
                </div>
              }
              @if (invoiceOcrGspModalData.fieldsPrefilled) {
                <div
                  class="grid grid-cols-[minmax(0,1fr)_auto_auto] items-center gap-3 text-sm"
                >
                  <span class="text-[#4a5871]">{{
                    "COO.OCR.GSP_MODAL.FIELDS_PREFILLED" | translate
                  }}</span>
                  <span class="text-right font-medium text-dc-black">{{
                    invoiceOcrGspModalData.fieldsPrefilled
                  }}</span>
                  <i class="fa-solid fa-circle-check text-[#16a34a]"></i>
                </div>
              }
            </div>
          </div>
        </div>

        <div class="mt-5 flex flex-col gap-3">
          <app-button
            classesName="card-edge-cut-white w-full"
            [label]="'COO.OCR.GSP_MODAL.CONTINUE_COO' | translate"
            (onBtnClick)="continueWithCooAfterOcr()"
          ></app-button>
          <app-button
            classesName="btn-edge-cut w-full"
            [label]="'COO.OCR.GSP_MODAL.SWITCH_GSP' | translate"
            (onBtnClick)="switchToGspAfterOcr()"
          ></app-button>
        </div>
      </div>
    </div>
  </dialog>
}
